import { render, staticRenderFns } from "./App.vue?vue&type=template&id=756efa2d&"
import script from "./app.ts?vue&type=script&lang=ts&"
export * from "./app.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QLayout,QHeader,QToolbar,QBtn,QToolbarTitle,QInput,QIcon,QPopupProxy,QList,QItem,QItemSection,QMenu,QSeparator,QDrawer,QBar,QSpace,QPageContainer,QBanner,QDialog,QCard,QTooltip,QCardSection,QLinearProgress,Ripple,ClosePopup} from 'quasar'
component.options.components = Object.assign({QLayout,QHeader,QToolbar,QBtn,QToolbarTitle,QInput,QIcon,QPopupProxy,QList,QItem,QItemSection,QMenu,QSeparator,QDrawer,QBar,QSpace,QPageContainer,QBanner,QDialog,QCard,QTooltip,QCardSection,QLinearProgress}, component.options.components || {})
component.options.directives = Object.assign({Ripple,ClosePopup}, component.options.directives || {})
